export default function BuyerProtectionPage() {
  return (
    <section className="legal">
      <h1>Buyer Protection</h1>
      <p className="muted">How NYGTIX keeps your purchase safe.</p>

      <h2>Your money is held in escrow</h2>
      <p>
        When you buy, your payment is held by NYGTIX — not paid to the seller right away. We only
        release it after you have your tickets.
      </p>

      <h2>Verified seats only</h2>
      <p>
        Every seat block on NYGTIX is reviewed and verified by our team before it can be listed, so
        you're buying from confirmed Season Ticket Holders.
      </p>

      <h2>You confirm before the seller is paid</h2>
      <p>
        The seller has 24 hours to transfer your tickets through the official Giants/Ticketmaster
        platform. Once you confirm receipt, we release payment. If you don't act, payment releases
        automatically 48 hours after the seller marks the tickets transferred.
      </p>

      <h2>Didn't get your tickets?</h2>
      <p>
        While your funds are in escrow — and up to 48 hours after the game — you can report a problem
        from your orders page. Our team reviews every dispute and will refund you in full from escrow
        if your tickets weren't delivered as described. Sellers who repeatedly fail to deliver are
        suspended.
      </p>

      <h2>No buyer fees</h2>
      <p>You pay the seller's listed price per seat. NYGTIX charges buyers no added fee.</p>
    </section>
  );
}
